import React, { useEffect } from "react";
import Select from "@amzn/meridian/select";
import { SelectOption } from "@amzn/meridian/select";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Tag from "@amzn/meridian/tag";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import {
  ROLE_OPTIONS,
  SELECT_ROLES_PLACEHOLDER,
  TOAST_MESSAGES,
  TOAST_NOTIFICATION_LEVELS,
} from "../constants/Constants";
import { updateSelectedRoles } from "../common/thunks/SelectedRolesDispatcher";
import { useToastNotification } from "../common/context/ToastNotificationContext";

const RolesDropdown = ({ onRolesChange }) => {
  const dispatch = useDispatch();
  const selectedRoles = useSelector((state) => state.selectedRoles);
  const { sendToastMessage } = useToastNotification();

  const handleRoleChange = (newValue) => {
    // Ensure we're working with an array for multi-select
    const rolesArray = Array.isArray(newValue) ? newValue : [newValue];

    // Prevent empty selection - show toast and don't update state
    if (rolesArray.length === 0) {
      sendToastMessage(
        "mySCC.roles.selectionRequired",
        TOAST_MESSAGES.ROLE_SELECTION_REQUIRED,
        TOAST_NOTIFICATION_LEVELS.WARNING,
      );
      return;
    }

    dispatch(updateSelectedRoles(rolesArray));
    if (onRolesChange) {
      onRolesChange(rolesArray);
    }
  };

  const handleTagClose = (roleValue) => {
    // Remove the role from the selected roles
    const updatedRoles = selectedRoles.filter((value) => value !== roleValue);
    dispatch(updateSelectedRoles(updatedRoles));
    if (onRolesChange) {
      onRolesChange(updatedRoles);
    }
  };

  // Call onRolesChange when selectedRoles changes from Redux
  useEffect(() => {
    if (onRolesChange && selectedRoles) {
      onRolesChange(selectedRoles);
    }
  }, [selectedRoles, onRolesChange]);

  return (
    <Row alignmentVertical="center">
      <Box>
        <Select
          value={selectedRoles}
          onChange={handleRoleChange}
          placeholder={
            <FormattedMessage
              id="mySCC.rolesDropdown.selectRoles"
              defaultMessage={SELECT_ROLES_PLACEHOLDER}
            />
          }
          width={200}
          size="small"
        >
          {ROLE_OPTIONS.map((role) => (
            <SelectOption
              key={role.value}
              value={role.value}
              label={role.label}
            />
          ))}
        </Select>
      </Box>
      <Box>
        {selectedRoles &&
          selectedRoles.map((roleValue) => {
            const role = ROLE_OPTIONS.find(
              (option) => option.value === roleValue,
            );
            return role ? (
              selectedRoles.length > 1 ? (
                <Tag
                  key={role.value}
                  type="neutral"
                  onClose={() => handleTagClose(role.value)}
                >
                  {role.label}
                </Tag>
              ) : (
                <Tag key={role.value} type="neutral">
                  {role.label}
                </Tag>
              )
            ) : null;
          })}
      </Box>
    </Row>
  );
};

export default RolesDropdown;



// WEBPACK FOOTER //
// ./src/components/mySCC/components/RolesDropdown.js